import * as React from "react";
import {Alert, Container, Form, Button, Card} from "react-bootstrap";
import {Formik} from "formik";
import {connect} from "react-redux";
import Yup from "yup";
import {loginUser} from "../../redux/user/action";
import withRequestState from "../../components/WithRequestState";
import { LOGIN_USER_REQUEST } from "../../redux/user/reducer";
import { RequestStateProps } from "../../interfaces/RequestState";
import { useHistory, withRouter, RouteComponentProps, Link } from "react-router-dom";
import {resetRequestState} from "../../redux/requests/action";


interface IProps {
    loginUser: (username : string, password : string) => void;
    resetRequestState: (types : string[]) => void;
}

class LoginPage extends React.Component<IProps & RequestStateProps & RouteComponentProps> {

    constructor(props){
        super(props);
    }

    submit(username : string, password : string){
        this.props.loginUser(username, password);
    }

    componentWillUnmount(){
        this.props.resetRequestState([LOGIN_USER_REQUEST]);
    }

    componentDidUpdate(){    
        if (this.props.isSuccessful){
            this.props.history.push("/projects");
        }
    }

    render(){
        return (
            <Container>
                
                <Alert variant="primary" className="mt-4">
                    You need to login
                </Alert>

                <Card>

                    <Card.Header>
                        <h1>Login</h1>
                    </Card.Header>

                    <Card.Body>                       

                        <Formik
                            initialValues={{
                                email: "",
                                password: ""
                            }}
                            onSubmit={({email, password}) => {
                                this.submit(email, password);    
                            }}
                        >
                            {props => (
                                <Form onSubmit={props.handleSubmit}>

                                    <Form.Group>

                                        <Form.Label>Email</Form.Label>
                                        <Form.Control 
                                            type="text"
                                            placeholder="example@abc.com"
                                            name="email"
                                            value={props.values.email}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                        />

                                    </Form.Group>

                                    <Form.Group>

                                        <Form.Label>Password</Form.Label>
                                        <Form.Control 
                                            type="password"
                                            placeholder="Password"
                                            name="password"
                                            value={props.values.password}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                        />

                                    </Form.Group>

                                    {
                                        this.props.hasError ? 
                                            <Alert variant="danger">
                                                Incorrect, please try again.
                                            </Alert> : null
                                    }

                                    <Button variant="primary" type="submit">Login</Button>

                                    <Alert variant="info" className="mt-3 d-block d-sm-flex align-items-center">
                                        <i className="material-icons pr-2">info</i>
                                        Don't have an account, click <Link to="/register" className="mx-1">here</Link> to register
                                    </Alert>

                                </Form>
                            )}
                        </Formik>

                    </Card.Body>

                </Card>
               


            </Container>
        )
    }

}


export default withRouter(connect(
    null,
    ({
        loginUser,
        resetRequestState
    })
)(withRequestState(LoginPage, [LOGIN_USER_REQUEST])));